import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialCashMachinePage() {
    const navigate = useNavigate();

    // States for calculation
    const [basket, setBasket] = useState(50); // Panier moyen
    const [clients, setClients] = useState(100); // Clients actuels / mois
    const [conversion, setConversion] = useState(1); // % Conversion actuel
    const [increase, setIncrease] = useState(0.5); // % Augmentation traffic/conv

    // Calculs
    const currentRevenue = basket * clients; // CA Mensuel actuel (simplifié)
    const newClients = Math.floor(clients * (1 + increase));
    const newRevenue = basket * newClients;
    const monthlyGain = newRevenue - currentRevenue;
    const yearlyGain = monthlyGain * 12;

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', color: 'white', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', flexDirection: 'column' }}>

            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: 40 }}>
                <button onClick={() => navigate('/commercial/launchpad')} style={{ background: 'rgba(255,255,255,0.1)', width: 50, height: 50, borderRadius: '50%', border: 'none', color: 'white', fontSize: '1.5rem', cursor: 'pointer' }}>←</button>
                <div>
                    <h1 style={{ fontSize: '2.5rem', fontWeight: 800, margin: 0 }}>💸 Cash Machine</h1>
                    <p style={{ opacity: 0.6, margin: 0 }}>Simulateur de Retour sur Investissement</p>
                </div>
            </div>

            <div style={{ display: 'flex', gap: 60, flex: 1 }}>

                {/* Controls */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 40, justifyContent: 'center' }}>

                    {/* Slider 1 */}
                    <div className="slider-group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                            <label style={{ fontSize: '1.2rem', fontWeight: 600 }}>Panier Moyen (€)</label>
                            <span style={{ fontSize: '1.5rem', fontWeight: 700, color: '#3b82f6' }}>{basket} €</span>
                        </div>
                        <input type="range" min="10" max="500" value={basket} onChange={e => setBasket(Number(e.target.value))} style={{ width: '100%' }} />
                    </div>

                    {/* Slider 2 */}
                    <div className="slider-group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                            <label style={{ fontSize: '1.2rem', fontWeight: 600 }}>Clients / Mois</label>
                            <span style={{ fontSize: '1.5rem', fontWeight: 700, color: '#a855f7' }}>{clients}</span>
                        </div>
                        <input type="range" min="10" max="1000" value={clients} onChange={e => setClients(Number(e.target.value))} style={{ width: '100%' }} />
                    </div>

                    {/* Slider 3 - Impact */}
                    <div className="slider-group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                            <label style={{ fontSize: '1.2rem', fontWeight: 600 }}>Impact Digital Estimé</label>
                            <span style={{ fontSize: '1.5rem', fontWeight: 700, color: '#22c55e' }}>+{Math.round(increase * 100)} %</span>
                        </div>
                        <input type="range" min="0.1" max="2" step="0.1" value={increase} onChange={e => setIncrease(Number(e.target.value))} style={{ width: '100%' }} />
                        <p style={{ opacity: 0.5, fontSize: '0.9rem', marginTop: 5 }}>Basé sur une refonte UX + SEO local</p>
                    </div>

                </div>

                {/* Results Visualizer */}
                <div style={{ flex: 1, background: 'rgba(255,255,255,0.05)', borderRadius: 32, padding: 40, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', border: '1px solid rgba(255,255,255,0.1)' }}>

                    <div style={{ fontSize: '1.2rem', opacity: 0.8, marginBottom: 10 }}>Gain net mensuel</div>
                    <div style={{ fontSize: '4rem', fontWeight: 800, color: 'white', marginBottom: 40 }}>
                        {monthlyGain > 0 ? '+' : ''}{monthlyGain.toLocaleString()} €
                    </div>

                    <div style={{ width: '100%', height: 2, background: 'rgba(255,255,255,0.1)', marginBottom: 40 }} />

                    <div style={{ fontSize: '1.5rem', opacity: 0.8, marginBottom: 20 }}>Gain sur 1 an</div>
                    <div className="animate-pulse-green" style={{ fontSize: '6rem', fontWeight: 900, color: '#4ade80', lineHeight: 1 }}>
                        {yearlyGain > 0 ? '+' : ''}{yearlyGain.toLocaleString()} €
                    </div>

                    <div style={{ marginTop: 40, padding: '15px 30px', background: '#22c55e', color: 'white', fontWeight: 700, borderRadius: 50, fontSize: '1.2rem', opacity: yearlyGain > 2000 ? 1 : 0.5 }}>
                        Rentable en {Math.max(1, Math.round(2000 / (monthlyGain || 1)))} mois *
                    </div>
                    <p style={{ opacity: 0.4, fontSize: '0.8rem', marginTop: 10 }}>* Pour un site à 2000€</p>

                </div>
            </div>

            <style>{`
                input[type=range] { width: 100%; cursor: pointer; height: 8px; border-radius: 5px; background: rgba(255,255,255,0.2); outline: none; -webkit-appearance: none; }
                input[type=range]::-webkit-slider-thumb { -webkit-appearance: none; width: 25px; height: 25px; border-radius: 50%; background: white; cursor: pointer; box-shadow: 0 0 10px rgba(0,0,0,0.3); }
                .animate-pulse-green { animation: pulseGreen 2s infinite; }
                @keyframes pulseGreen { 0% { text-shadow: 0 0 0 rgba(74, 222, 128, 0); } 50% { text-shadow: 0 0 30px rgba(74, 222, 128, 0.5); } 100% { text-shadow: 0 0 0 rgba(74, 222, 128, 0); } }
            `}</style>
        </div>
    );
}
